<template>
    <center-layout>
        <h2 class="pb-4">
            Welcome to Diario. Please
            <router-link to="/">sign in</router-link> or sign up to get started.
        </h2>

        <v-alert type="error" v-if="error" v-text="error"></v-alert>
        <v-form>
            <v-text-field
                v-model="name"
                type="text"
                label="Name"
                hint="Your display name"
                outlined
            />
            <v-text-field
                v-model="email"
                type="email"
                label="Email"
                hint="The email you want to login with"
                outlined
            />
            <v-text-field
                v-model="password"
                label="Password"
                hint="Must be at least 10 characters long"
                :counter="password.length > 0"
                :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show_password ? 'text' : 'password'"
                @click:append="show_password = !show_password"
                outlined
            />
            <v-text-field
                v-model="confirm_password"
                label="Confirm Password"
                hint="Must be at least 10 characters long and match the password"
                :counter="confirm_password.length > 0"
                :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show_password ? 'text' : 'password'"
                @click:append="show_password = !show_password"
                outlined
            />
            <v-btn
                block
                color="primary"
                :disabled="
                    name === '' ||
                        email === '' ||
                        password === '' ||
                        confirm_password === '' ||
                        password !== confirm_password ||
                        (password.length < 10 && confirm_password.length < 10)
                "
                @click="signup"
            >
                Sign Up
            </v-btn>
        </v-form>
    </center-layout>
</template>

<script>
import firebase from "firebase";
import CenterLayout from "../components/CenterLayout.vue";

export default {
    name: "Signup",
    components: { CenterLayout },
    data: function() {
        return {
            name: "",
            email: "",
            password: "",
            confirm_password: "",
            show_password: false,
            error: false
        };
    },
    methods: {
        signup: function() {
            firebase
                .auth()
                .createUserWithEmailAndPassword(this.email, this.password)
                .then(data => {
                    data.user
                        .updateProfile({
                            displayName: this.name
                        })
                        .then(() => {
                            this.$router.replace({ name: "Entries" });
                        })
                        .catch(error => {
                            this.error = error.message;
                        });
                })
                .catch(error => {
                    this.error = error.message;
                });
        }
    }
};
</script>
